export const headerNavItems = [
  { label: '首页', href: '#hero' },
  { label: '热门榜单', href: '#ranking' },
  { label: '常见问答', href: '#faq' },
  { label: '专题合集', href: '#index' },
  { label: 'APP下载', href: '#app' },
  { label: '联系投稿', href: '#contact' },
  { label: '媒体聚焦', href: '#media' },
];

export const cardsData = [
  {
    id: 'card-1',
    title: '顶流塌房后续：品牌方连夜解约，粉丝后援会集体脱粉',
    summary: '多家品牌方在事件曝光后四小时内发布解约声明，相关话题阅读量突破12亿，引发全网热议。业内人士透露后续还有更多料待爆。',
    tag: '独家爆料',
    tagColor: 'bg-primary-500',
    time: '2小时前',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20concept%20art%20of%20a%20shattered%20spotlight%20on%20a%20dark%20stage%2C%20broken%20glass%20pieces%20floating%2C%20warm%20dramatic%20lighting%2C%20editorial%20composition%2C%20cinematic%20mood%2C%20rich%20contrast%2C%20no%20text&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 'card-2',
    title: '某综艺录制现场突发状况，节目组紧急发声明回应争议',
    summary: '最新一期节目录制中发生意外插曲，现场观众透露细节令人震惊。节目组深夜连发三份声明，称将对涉事人员进行严肃处理。',
    tag: '实时追踪',
    tagColor: 'bg-accent-500',
    time: '5小时前',
    views: '96.3万',
    image: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20dramatic%20red%20and%20warm%20spotlights%2C%20empty%20stage%20with%20microphones%2C%20tense%20atmosphere%2C%20cinematic%20photography%2C%20high%20contrast%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 'card-3',
    title: '网红情侣分手互撕升级，双方晒出聊天记录锤对方',
    summary: '从甜蜜合拍到公开互撕，这对千万粉丝网红情侣的分手大戏持续发酵。双方各自放出截图证据，网友吃瓜吃到停不下来。',
    tag: '热搜',
    tagColor: 'bg-primary-500',
    time: '8小时前',
    views: '215.7万',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20concept%20with%20two%20smartphones%20on%20a%20dark%20surface%20showing%20chat%20bubbles%2C%20dramatic%20warm%20lighting%2C%20tense%20mood%2C%20editorial%20photography%2C%20rich%20shadows%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 'card-4',
    title: '年度颁奖礼名单疑似泄露，多位艺人排名引发争议',
    summary: '一份标注"内部文件"的颁奖礼入围名单在社交平台疯传，多个奖项的提名引发粉丝群体激烈讨论，主办方尚未正式回应。',
    tag: '内幕',
    tagColor: 'bg-secondary-500',
    time: '12小时前',
    views: '87.2万',
    image: 'https://readdy.ai/api/search-image?query=A%20golden%20trophy%20on%20a%20dark%20velvet%20pedestal%20with%20dramatic%20spotlight%2C%20mysterious%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20lighting%2C%20editorial%20photography%2C%20high%20contrast%2C%20no%20text&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 'card-5',
    title: '选秀节目选手背景被深扒，素人人设遭质疑真实性',
    summary: '热门选秀选手被网友扒出过往经历与节目中描述大相径庭，其经纪公司发表声明称"尊重多元表达"，评论区彻底沦陷。',
    tag: '深度扒皮',
    tagColor: 'bg-primary-500',
    time: '1天前',
    views: '176.4万',
    image: 'https://readdy.ai/api/search-image?query=A%20silhouette%20of%20a%20person%20on%20a%20bright%20stage%20with%20a%20large%20magnifying%20glass%20overlay%2C%20investigative%20mood%2C%20warm%20dramatic%20lighting%2C%20cinematic%20composition%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=card-05&orientation=landscape',
  },
];

export const topicsData = [
  { id: 'topic-1', name: '#某顶流塌房', heat: '1286万讨论', trend: 'up', icon: 'ri-fire-line' },
  { id: 'topic-2', name: '#综艺录制事故', heat: '963万讨论', trend: 'up', icon: 'ri-flashlight-line' },
  { id: 'topic-3', name: '#网红情侣互撕', heat: '2157万讨论', trend: 'hot', icon: 'ri-emotion-sad-line' },
  { id: 'topic-4', name: '#颁奖礼名单泄露', heat: '872万讨论', trend: 'up', icon: 'ri-award-line' },
  { id: 'topic-5', name: '#选秀选手人设', heat: '1764万讨论', trend: 'up', icon: 'ri-spy-line' },
  { id: 'topic-6', name: '#某女星嫁入豪门', heat: '3421万讨论', trend: 'hot', icon: 'ri-vip-crown-line' },
  { id: 'topic-7', name: '#电影票房造假', heat: '698万讨论', trend: 'new', icon: 'ri-film-line' },
  { id: 'topic-8', name: '#综艺CP假戏真做', heat: '1543万讨论', trend: 'up', icon: 'ri-heart-add-line' },
  { id: 'topic-9', name: '#经纪人录音门', heat: '2109万讨论', trend: 'hot', icon: 'ri-mic-line' },
];

export const commentsData = [
  {
    id: 'comment-1',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20portrait%20avatar%20of%20a%20young%20person%2C%20minimal%20style%2C%20warm%20tones%2C%20simple%20background%2C%20profile%20picture%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '3分钟前',
    content: '这次真的惊到我了，凌晨三点还在刷相关话题，根本停不下来。只能说贵圈的水太深，我们看到的只是冰山一角。',
    likes: 1283,
  },
  {
    id: 'comment-2',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20portrait%20avatar%20of%20a%20trendy%20person%2C%20minimal%20style%2C%20warm%20tones%2C%20simple%20background%2C%20profile%20picture%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '理性吃瓜群众',
    time: '15分钟前',
    content: '建议等官方回应再下结论。不过这次的聊天记录看起来挺真的，如果是P的那技术也太牛了。搬好小板凳等后续。',
    likes: 867,
  },
  {
    id: 'comment-3',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20portrait%20avatar%20of%20a%20cool%20person%2C%20minimal%20style%2C%20warm%20tones%2C%20simple%20background%2C%20profile%20picture%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '前线记者小王',
    time: '28分钟前',
    content: '我在现场附近看到了好几家媒体的车，据说还有更多猛料在路上。今天注定是个不眠夜，大家准备好瓜子饮料。',
    likes: 2156,
  },
  {
    id: 'comment-4',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20portrait%20avatar%20of%20a%20fashionable%20person%2C%20minimal%20style%2C%20warm%20tones%2C%20simple%20background%2C%20profile%20picture%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '深夜吃瓜选手',
    time: '42分钟前',
    content: '每当我以为已经够离谱的时候，总会有更离谱的事情发生。这个月的瓜田真是大丰收，一个比一个炸裂。',
    likes: 945,
  },
  {
    id: 'comment-5',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20portrait%20avatar%20of%20a%20casual%20person%2C%20minimal%20style%2C%20warm%20tones%2C%20simple%20background%2C%20profile%20picture%20style&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '八卦研究员',
    time: '1小时前',
    content: '时间线整理完毕，发现这件事其实从三个月前就有端倪了。建议大家去搜一下去年那条采访，细思极恐。',
    likes: 1678,
  },
];

export const aboutData = {
  title: '关于吃瓜51',
  paragraphs: [
    '吃瓜51网是国内领先的娱乐八卦与热门事件聚合平台，致力于为用户提供最新、最全、最快的吃瓜爆料资讯。我们汇聚全网热门话题、网红动态、娱乐圈内幕以及各类社会热点事件，让每一位用户都能第一时间掌握最有料的内容。',
    '平台以"真实、快速、有态度"为核心理念，坚持从多个信息源交叉验证事件真实性，同时保持内容的趣味性和可读性。无论是娱乐圈的大事小情，还是网络红人的动态追踪，甚至是社会突发事件的深度解读，吃瓜51都能为你提供全方位的资讯服务。',
    '我们相信，每一颗瓜都值得被认真对待。吃瓜51不仅是一个信息平台，更是一个让广大网友理性讨论、分享观点的社区空间。每天数千万用户在这里获取最新爆料，发表独到见解，共同见证每一个热门事件的起承转合。',
  ],
  stats: [
    { value: '5000万+', label: '月活跃用户' },
    { value: '10万+', label: '日均更新内容' },
    { value: '300+', label: '合作媒体渠道' },
  ],
};

export const carouselData = [
  {
    id: 'carousel-1',
    title: '某顶流塌房事件全纪录',
    tag: '焦点专题',
    summary: '从粉丝脱粉到品牌解约，这场席卷全网的塌房风暴完整时间线梳理，包含独家获取的内部消息和多角度深度分析。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20conceptual%20image%20of%20a%20falling%20star%20on%20a%20dark%20stage%2C%20warm%20theatrical%20lighting%2C%20cinematic%20composition%2C%20editorial%20style%2C%20rich%20contrast%2C%20dramatic%20atmosphere%2C%20no%20text&width=1200&height=700&seq=carousel-01&orientation=landscape',
    reads: '2568万',
    commentCount: '12.6万',
  },
  {
    id: 'carousel-2',
    title: '网红经济背后的灰色产业链',
    tag: '深度调查',
    summary: '揭开网红刷量、数据造假、MCN机构运作内幕，深度报道行业内不为人知的商业逻辑和潜规则。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20conceptual%20image%20of%20shadowy%20figures%20behind%20a%20glowing%20phone%20screen%2C%20dark%20business%20atmosphere%2C%20warm%20accent%20lighting%2C%20cinematic%20noir%20style%2C%20editorial%20photography%2C%20no%20text&width=1200&height=700&seq=carousel-02&orientation=landscape',
    reads: '1892万',
    commentCount: '8.3万',
  },
  {
    id: 'carousel-3',
    title: '年度娱乐圈大事记盘点',
    tag: '年度特辑',
    summary: '回顾过去一年娱乐圈最具话题性的十大事件，从恋爱官宣到意外塌房，每一件都曾霸占热搜榜首。',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20golden%20spotlights%20and%20floating%20headlines%20on%20a%20dark%20background%2C%20celebration%20mood%2C%20warm%20golden%20tones%2C%20editorial%20style%2C%20cinematic%20composition%2C%20no%20text&width=1200&height=700&seq=carousel-03&orientation=landscape',
    reads: '3125万',
    commentCount: '18.9万',
  },
  {
    id: 'carousel-4',
    title: '综艺节目幕后潜规则揭秘',
    tag: '独家专题',
    summary: '多位业内人士匿名爆料综艺节目制作过程中的剧本安排、剪辑套路和选手内定机制，信息量巨大。',
    image: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20concept%20with%20TV%20cameras%20and%20shadowy%20figures%2C%20mysterious%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20no%20text&width=1200&height=700&seq=carousel-04&orientation=landscape',
    reads: '1437万',
    commentCount: '7.1万',
  },
  {
    id: 'carousel-5',
    title: '当红明星商业价值排行榜',
    tag: '数据报告',
    summary: '基于品牌代言、社交媒体影响力、作品成绩等维度，全面解析当前一线明星的真实商业价值排名。',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20glowing%20ranking%20charts%20and%20stars%20on%20a%20dark%20background%2C%20data%20visualization%20style%2C%20warm%20golden%20accent%2C%20editorial%20design%2C%20cinematic%20mood%2C%20no%20text&width=1200&height=700&seq=carousel-05&orientation=landscape',
    reads: '987万',
    commentCount: '5.4万',
  },
];

export const rankingData = [
  { rank: 1, title: '顶流艺人塌房事件：品牌集体解约潮', heat: '1286万', trend: 'hot', change: 'new' },
  { rank: 2, title: '网红情侣分手互撕聊天记录曝光', heat: '2157万', trend: 'up', change: 'up3' },
  { rank: 3, title: '某女星嫁入豪门婚礼细节曝光', heat: '3421万', trend: 'hot', change: 'up1' },
  { rank: 4, title: '综艺录制现场突发意外节目组回应', heat: '963万', trend: 'up', change: 'up2' },
  { rank: 5, title: '经纪人录音门：多段对话内容流出', heat: '2109万', trend: 'hot', change: 'up5' },
  { rank: 6, title: '选秀节目选手真实背景被深挖', heat: '1764万', trend: 'up', change: 'down1' },
  { rank: 7, title: '颁奖礼提名名单疑似提前泄露', heat: '872万', trend: 'new', change: 'new' },
];

export const indexData = [
  {
    id: 'index-1',
    title: '娱乐圈顶流塌房专题',
    count: '36篇',
    desc: '汇集近期所有顶流艺人塌房事件的最新进展和深度分析',
    icon: 'ri-alert-line',
  },
  {
    id: 'index-2',
    title: '网红圈恩怨局全记录',
    count: '28篇',
    desc: '网红之间的互撕、爆料和反转剧情一网打尽',
    icon: 'ri-sword-line',
  },
  {
    id: 'index-3',
    title: '综艺节目争议合集',
    count: '42篇',
    desc: '各档综艺节目的争议片段、幕后爆料和制作内幕',
    icon: 'ri-tv-2-line',
  },
  {
    id: 'index-4',
    title: '明星私生活追踪',
    count: '55篇',
    desc: '明星恋情、婚姻、家庭等私生活话题的最新动态',
    icon: 'ri-eye-line',
  },
  {
    id: 'index-5',
    title: '影视圈内幕揭秘',
    count: '31篇',
    desc: '票房造假、选角内幕、片场八卦等影视行业深度报道',
    icon: 'ri-film-line',
  },
  {
    id: 'index-6',
    title: '社会热点事件吃瓜',
    count: '47篇',
    desc: '从娱乐视角解读社会热点事件，提供不一样的角度',
    icon: 'ri-global-line',
  },
  {
    id: 'index-7',
    title: '年度十大吃瓜事件',
    count: '10篇',
    desc: '年度最具影响力的十大事件完整回顾与深度解析',
    icon: 'ri-trophy-line',
  },
];

export const appData = {
  title: '吃瓜51 APP — 随时随地吃新鲜瓜',
  desc: '下载吃瓜51官方APP，第一时间获取最新爆料推送。支持iOS和Android双平台，界面简洁流畅，夜间模式保护视力，让你在被窝里也能安心吃瓜。',
  features: ['实时推送不延迟', '独家内容抢先看', '夜间模式护眼', '社区互动更精彩'],
  qrImage: 'https://readdy.ai/api/search-image?query=A%20minimal%20QR%20code%20style%20design%20with%20abstract%20geometric%20pattern%2C%20warm%20coral%20and%20white%20color%20scheme%2C%20clean%20modern%20design%2C%20simple%20background&width=300&height=300&seq=app-qr&orientation=squarish',
  appImage: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20showing%20a%20news%20and%20gossip%20app%20interface%20with%20warm%20coral%20theme%2C%20clean%20modern%20UI%20design%2C%20entertainment%20news%20feed%20layout%2C%20minimal%20style%2C%20on%20a%20light%20background&width=600&height=800&seq=app-screen&orientation=portrait',
};

export const featuresData = [
  {
    id: 'feature-1',
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时不间断监测全网热点，事件发生第一时间推送通知，让你永远快人一步掌握最新瓜情。',
  },
  {
    id: 'feature-2',
    icon: 'ri-shield-check-line',
    title: '多方求证',
    desc: '每条爆料都经过多信息源交叉验证，标注信息来源和可信度等级，拒绝虚假信息和恶意造谣。',
  },
  {
    id: 'feature-3',
    icon: 'ri-user-voice-line',
    title: '用户共创',
    desc: '开放投稿通道，鼓励用户分享独家线索和深度分析，优质内容提供者将获得平台流量扶持和奖励。',
  },
  {
    id: 'feature-4',
    icon: 'ri-smartphone-line',
    title: '全端覆盖',
    desc: '支持网页端、移动APP、小程序等多终端访问，数据实时同步，随时随地畅享吃瓜乐趣。',
  },
];

export const updatesData = [
  {
    id: 'update-1',
    time: '10分钟前',
    title: '某艺人工作室发布律师函，将对近期不实传闻追究法律责任',
    tag: '最新',
    tagColor: 'bg-primary-500',
  },
  {
    id: 'update-2',
    time: '28分钟前',
    title: '综艺节目组正式回应录制事故，涉事工作人员已被停职',
    tag: '跟进',
    tagColor: 'bg-accent-500',
  },
  {
    id: 'update-3',
    time: '1小时前',
    title: '网红情侣双方各自发布长文，事件出现重大反转',
    tag: '反转',
    tagColor: 'bg-primary-500',
  },
  {
    id: 'update-4',
    time: '2小时前',
    title: '颁奖礼主办方否认名单泄露，称将启动内部调查程序',
    tag: '回应',
    tagColor: 'bg-secondary-500',
  },
  {
    id: 'update-5',
    time: '3小时前',
    title: '多个品牌同时发布解约公告，涉及代言金额或超亿元',
    tag: '突发',
    tagColor: 'bg-primary-500',
  },
  {
    id: 'update-6',
    time: '5小时前',
    title: '网友发现更多蛛丝马迹，相关证据链逐渐完整',
    tag: '深挖',
    tagColor: 'bg-accent-500',
  },
  {
    id: 'update-7',
    time: '7小时前',
    title: '圈内人士匿名爆料更多内幕，称还有更大瓜待公布',
    tag: '预告',
    tagColor: 'bg-primary-500',
  },
  {
    id: 'update-8',
    time: '9小时前',
    title: '相关话题阅读量累计突破50亿，创下平台单日新纪录',
    tag: '数据',
    tagColor: 'bg-secondary-500',
  },
];

export const faqData = [
  {
    id: 'faq-1',
    question: '吃瓜51网的内容来源是否可靠？',
    answer: '我们建立了严格的内容审核机制，所有爆料均标注信息来源和可信度等级。重要事件会进行多信息源交叉验证，确保为用户提供真实可靠的吃瓜资讯。对于无法核实的内容，我们会在显著位置标注"待核实"标签。',
  },
  {
    id: 'faq-2',
    question: '如何向吃瓜51投稿或提供线索？',
    answer: '你可以通过网站底部的"联系投稿"入口提交线索，或发送邮件至我们的官方投稿邮箱。我们会对每一条投稿进行审核，优质内容和独家爆料将获得平台首页推荐机会。投稿人信息严格保密。',
  },
  {
    id: 'faq-3',
    question: '吃瓜51网的内容更新频率如何？',
    answer: '我们的编辑团队实行7×24小时轮班制，全天候监控全网热点动态。重大事件发生后通常在15分钟内完成首条快讯发布，30分钟内推出完整报道，确保用户第一时间获取最新资讯。',
  },
  {
    id: 'faq-4',
    question: '吃瓜51APP有哪些特色功能？',
    answer: '吃瓜51APP支持实时推送通知、夜间模式阅读、离线缓存、社区评论互动等功能。我们还提供个性化订阅服务，用户可以选择关注特定类型的内容，获得更精准的推送体验。',
  },
  {
    id: 'faq-5',
    question: '遇到不实信息或侵权内容如何处理？',
    answer: '我们尊重每个人的合法权益。如发现平台内容存在不实信息或侵犯您的权益，请通过"联系投稿"页面提交申诉，我们的法务团队会在24小时内进行处理。经核实的内容将立即下架并发布更正声明。',
  },
  {
    id: 'faq-6',
    question: '吃瓜51网是否收费？',
    answer: '吃瓜51网的核心内容完全免费开放。我们通过品牌广告合作维持平台运营，确保所有用户都能无障碍地获取最新吃瓜资讯。未来推出的增值服务将明确标注，并始终保持基础功能的免费性。',
  },
];

export const mediaData = [
  {
    id: 'media-1',
    title: '独家对话：圈内人士揭秘娱乐圈潜规则',
    duration: '15:28',
    views: '326万',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20interview%20scene%20with%20a%20silhouette%20figure%20against%20warm%20studio%20lighting%2C%20anonymous%20interview%20mood%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20dramatic%20contrast%2C%20no%20text&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    id: 'media-2',
    title: '深度分析：2026上半年娱乐圈大事件回顾',
    duration: '22:15',
    views: '489万',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20timeline%20with%20floating%20event%20cards%20on%20a%20dark%20background%2C%20warm%20golden%20highlights%2C%20editorial%20design%20style%2C%20cinematic%20mood%2C%20rich%20texture%2C%20no%20text&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    id: 'media-3',
    title: '直播回放：顶流塌房事件全网第一现场',
    duration: '45:02',
    views: '1287万',
    date: '2026-07-22',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20live%20broadcast%20studio%20with%20red%20breaking%20news%20theme%2C%20dramatic%20warm%20lighting%2C%20newsroom%20atmosphere%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    id: 'media-4',
    title: '专题片：网红经济泡沫何时破裂？',
    duration: '18:40',
    views: '756万',
    date: '2026-07-19',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20floating%20social%20media%20icons%20and%20dollar%20signs%20on%20a%20dark%20background%2C%20economic%20theme%2C%20warm%20golden%20accents%2C%20editorial%20style%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export const footerLinks = [
  { label: '关于我们', href: '#about' },
  { label: '联系投稿', href: '#contact' },
  { label: '常见问答', href: '#faq' },
  { label: 'APP下载', href: '#app' },
  { label: '用户协议', href: '#faq' },
  { label: '隐私政策', href: '#faq' },
  { label: '版权声明', href: '#faq' },
];